import { render, staticRenderFns } from "./TraspasoSubTab.vue?vue&type=template&id=2456272a&"
import script from "./TraspasoSubTab.vue?vue&type=script&lang=js&"
export * from "./TraspasoSubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports